import React from 'react';
import { useEffect, useState } from "react";
import { Field } from "redux-form";
import {
  FormGroup,
  Transition,
  Divider,
  Popup,
  Button,
} from "semantic-ui-react";
import { TextInput, FileInput, CheckboxInput } from "../../utils/form-fields";

const PackshotTab = ({ banner, handleUpload, change }) => {
  const [showPackshots, setShowPackshots] = useState(false);
  const [showSecondPackshot, setShowSecondPackshot] = useState(false);
  const [packshotSize, setPackshotSize] = useState({
    maxWidth: 370,
    height: 264,
  });
  const [disableCheckbox, setDisableCheckbox] = useState(false);

  useEffect(() => {
    if (banner.fields) {
      let showValue = banner.fields.ShowPackshots;
      if (showValue === "yes") showValue = true;
      if (showValue === "no") showValue = false;
      setShowPackshots(showValue);
    }
  }, [banner]);

  useEffect(() => {
    if (banner.fields) {
      setShowSecondPackshot(banner.fields.AddSecondPackshot);

      if (banner.fields.MainPackshot) {
        let { MainPackshot } = banner.fields;
        setDisableCheckbox(MainPackshot.width > 370);
      }
    }
  }, [banner]);

  useEffect(() => {
    const size = showSecondPackshot
      ? { maxWidth: 370, height: 264 }
      : { maxWidth: 560, height: 264 };
    setPackshotSize(size);
  }, [showSecondPackshot]);

  return (
    <>
      <Field
        component={CheckboxInput}
        name={`fields.ShowPackshots`}
        label="Show packshots"
        type="checkbox"
      />
      <Divider hidden />
      <Transition visible={showPackshots} animation="slide down" duration={200}>
        <div>
          <FormGroup>
            <div className="field">
              <label>Main Packshot</label>
              {banner.fields &&
                banner.fields.MainPackshot &&
                banner.fields.MainPackshot.path && (
                  <>
                    <p>
                      {Math.round(banner.fields.MainPackshot.size / 1000)} kb |{" "}
                      {banner.fields.MainPackshot.width}x
                      {banner.fields.MainPackshot.height}
                    </p>
                    <img
                      src={banner.fields.MainPackshot.path}
                      alt={banner.fields.MainPackshotDescription}
                    />
                  </>
                )}
              <Field
                name={`fields.MainPackshot`}
                component={FileInput}
                fileName={
                  banner.fields &&
                  banner.fields.MainPackshot &&
                  banner.fields.MainPackshot.name
                    ? banner.fields.MainPackshot.name
                    : ""
                }
                callback={(file) =>
                  handleUpload(
                    file,
                    `fields.MainPackshot`,
                    "Main packshot description",
                    packshotSize
                  )
                }
                handleFileRemove={(e) => change(`fields.MainPackshot`, {})}
              />
            </div>
            <Field
              component={TextInput}
              name={`fields.MainPackshotDescription`}
              type="text"
              label="Packshot description"
              width="8"
            />
            <div className="field popup">
              <Popup
                content="For screen readers. Please include the name or a description of the product or products."
                trigger={<Button icon="question" />}
              />
            </div>
          </FormGroup>
        </div>
      </Transition>
      <Divider hidden />

      <Field
        component={CheckboxInput}
        name={`fields.AddSecondPackshot`}
        label="Add second packshot"
        type="checkbox"
        disable={disableCheckbox}
      />
      {disableCheckbox && (
        <p>The primary packshot is now too wide to add a second one</p>
      )}
      <Divider hidden />
      <Transition
        visible={showSecondPackshot}
        animation="slide down"
        duration={200}
      >
        <div>
          <FormGroup>
            <div className="field">
              <label>Second Packshot</label>
              {banner.fields &&
                banner.fields.SecondPackshot &&
                banner.fields.SecondPackshot.path && (
                  <>
                    <p>
                      {Math.round(banner.fields.SecondPackshot.size / 1000)} kb
                    </p>
                    <img
                      src={banner.fields.SecondPackshot.path}
                      alt={banner.fields.SecondPackshotDescription}
                    />
                  </>
                )}
              <Field
                name={`fields.SecondPackshot`}
                component={FileInput}
                fileName={
                  banner.fields &&
                  banner.fields.SecondPackshot &&
                  banner.fields.SecondPackshot.name
                    ? banner.fields.SecondPackshot.name
                    : ""
                }
                callback={(file) =>
                  handleUpload(
                    file,
                    `fields.SecondPackshot`,
                    "Second packshot description",
                    { maxWidth: 370, height: 264 }
                  )
                }
                handleFileRemove={(e) => change(`fields.SecondPackshot`, {})}
              />
            </div>
            <Field
              component={TextInput}
              name={`fields.SecondPackshotDescription`}
              type="text"
              label="Packshot description"
              width="8"
            />
            <div className="field popup">
              <Popup
                content="For screen readers. Please include the name or a description of the product."
                trigger={<Button icon="question" />}
              />
            </div>
          </FormGroup>
        </div>
      </Transition>
    </>
  );
};

export default PackshotTab;
